import { FiEye } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'

import { stripeAPI } from '../api/services/stripe'
import { TransactionData } from '../api/services/stripe/types.ts'
import { useAuth } from '../context/auth'
import { convertToShortDateFromSeconds } from './formatter.ts'
import { formatCurrency } from './payments.ts'
import { isUserExistsInGroup } from './userRights.ts'

type TableColumn = {
  header: string
  accessor: string
  render: (row: TransactionData) => JSX.Element
  className: string
  classNameTd: string
}

export const setTableColumns = (transactionsType: 'charges' | 'payouts') => {
  const tableColumns: TableColumn[] =
    transactionsType === 'charges'
      ? [
          {
            header: 'Data transakcji',
            accessor: 'date',
            className: 'text-center',
            classNameTd: 'text-center',
            render: (row: TransactionData) => (
              <>{convertToShortDateFromSeconds(row.created)}</>
            )
          },
          {
            header: 'Kwota',
            accessor: 'amount',
            render: (row: TransactionData) => (
              <>
                {formatCurrency(row.amount - row.application_fee_amount) +
                  ' ' +
                  row.currency.toUpperCase()}
              </>
            ),
            className: 'w-[200px] text-right md:w-[120px]',
            classNameTd: 'text-right'
          },
          {
            header: 'Status',
            accessor: 'status',
            render: (row: TransactionData) => (
              <>{row.status === 'succeeded' ? 'Zrealizowano' : row.status}</>
            ),
            className: 'text-center',
            classNameTd: 'text-center'
          }
        ]
      : [
          {
            header: 'Data',
            accessor: 'date',
            className: 'text-center',
            classNameTd: 'text-center',
            render: (row: TransactionData) => (
              <>{convertToShortDateFromSeconds(row.created)}</>
            )
          },
          {
            header: 'Kwota',
            accessor: 'amount',
            render: (row: TransactionData) => (
              <>
                {formatCurrency(row.amount - row.application_fee_amount) +
                  ' ' +
                  row.currency.toUpperCase()}
              </>
            ),
            className: 'w-[170px] text-center',
            classNameTd: 'text-right'
          },
          {
            header: 'Dostępna w banku',
            accessor: 'status',
            render: (row: TransactionData) => (
              <>{convertToShortDateFromSeconds(row.arrival_date)}</>
            ),
            className: 'text-center',
            classNameTd: 'text-center'
          },
          {
            header: 'Status',
            accessor: 'status',
            render: (row: TransactionData) => (
              <>{row.status === 'paid' ? 'Wysłano' : row.status}</>
            ),
            className: 'text-center',
            classNameTd: 'text-center'
          }
        ]

  return tableColumns
}

export const setTableActions = (transactionsType: 'charges' | 'payouts') => {
  const navigate = useNavigate()
  const { state } = useAuth()
  const isMainUser = isUserExistsInGroup(state.groups, 'dd_panel_main_users')

  const getOrderId = async (row: TransactionData) => {
    if (isMainUser) {
      // only for main user transactions payment intent id is filled
      const { id } = await stripeAPI.getOrderByPaymentIntentId(
        row.payment_intent
      )
      return id
    } else {
      const { id } = await stripeAPI.getOrderByTransferId(row.source_transfer)
      return id
    }
  }

  const tableActions =
    transactionsType === 'charges'
      ? [
          {
            label: 'Przejdź do zamówienia',
            icon: <FiEye className="text-lg" />,
            onClick: async (row: TransactionData) => {
              const id = await getOrderId(row).catch(() => undefined)
              id && navigate(`/orders/${id}/`)
            },
            className: 'text-blue-500 text-xl',
            visible: (row: TransactionData) => row.transfer_data === null
          },
        {
          label: 'Transakcja na Sub koncie',
          onClick: () => null,
          visible: (row: TransactionData) => row.transfer_data !== null
        }
        ]
      : undefined
  return tableActions
}
